<script>
    export let selected;
</script>

<label class="switch">
    <input type="checkbox" bind:checked={selected}>
    <div class="slider">
        <span class="on">On</span>
        <span class="off">Off</span>
    </div>
</label>

<style>
    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 56px;
        height: 30px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white;
        transition: .4s;
        border: 1px solid #719500;
        border-radius: 30px;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 24px;
        width: 24px;
        left: 2px;
        bottom: 2px;
        background-color: #719500;
        transition: .4s;
        border-radius: 50%;
    }

    input:checked + .slider {
        background-color: rgba(119, 184, 0, 0.4);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px rgba(119, 184, 0, 0.4);
    }

    input:checked + .slider:before {
        background-color: #719500;
        transform: translateX(26px);
    }

    /* Text */
    .on {
        display: none;
        position: absolute;
        left: 6px;
    }
    .off {
        position: absolute;
        right: 6px;
    }

    .on, .off {
        color: #719500;
        font-size: 10px;
        user-select: none;
        top: 50%;
        transform: translateY(-60%);
        text-transform: uppercase;
    }

    input:checked+ .slider .on {
        display: block;
    }

    input:checked + .slider .off {
        display: none;
    }
</style>